/**
 * `gap` is in spacing steps and is Figma's `radio/p` plus its zero item spacing: the theme negates the
 * 8px affordance, so the label has to stand that far off the ring itself to land where Figma draws it.
 */
export const RADIO_LABEL = { gap: 1, variant: "body2" } as const;
